<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <!-- <div class="md-toolbar-section-start"> -->
        <div class="md-collapse" style="justify-content: flex-end">

          <md-list>

            <md-list-item
              
              v-if="formConfig.pageMode === 'edit'"
              v-on:click="save"
              :disabled="btnActive ? ($v.form.$invalid) : ($v.form.$invalid || !$v.form.$anyDirty)"
            >
              <i class="material-icons">save</i>
              <p class="hidden-lg hidden-md">Save</p>
            </md-list-item>

            <md-list-item
              
              v-if="formConfig.pageMode === 'edit'" v-on:click="cancel"
            >
              <i class="material-icons">close</i>
              <p class="hidden-lg hidden-md">Cancel</p>
            </md-list-item>

            <md-list-item
              
              v-if="formConfig.pageMode === 'view' || formConfig.pageMode === 'assignee'" @click="formConfig.pageMode = 'edit'"
            >
              <i class="material-icons">edit</i>
              <p class="hidden-lg hidden-md">Edit</p>
            </md-list-item>

            <li class="md-list-item" v-if="$Session.user">
              <a
                :href="'#' + $route.path"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>more_vert</md-icon>
                      <p class="hidden-lg hidden-md">More Options</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li>
                        <a @click="atShowAuditLog">
                          <md-icon>visibility</md-icon> Audit Log
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

          </md-list>
        </div>
      <!-- </div> -->
      <!-- <div class="md-toolbar-section-end">

        
      </div> -->
    </div>
  </md-toolbar>
</template>

<script>
  export default {
    name: "custom-crud-toolbar",
    components: {},
    props: {
      cancel: {
        type: Function,
        required: true
      },
      save: {
        type: Function,
        required: true
      },
      formConfig: {
        type: Object,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $v: {
        type: Object,
        required: true
      },
      btnActive: {
        type: Boolean
      },
      atShowAuditLog: {
        type: Function,
        required: false,
        default: () => ({})
      },
    },
    data() {
      return {}
    },
    methods: {
      
    }
  };
</script>
<style>
body.isCaseDialogOpen {
  overflow-y: hidden;
}
</style>